import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, Form, InputGroup, Alert } from 'react-bootstrap';
function Greet() {
    const [nameInput, setNameInput] = useState("");
    const [reflectedName, setReflectedName] = useState("");
    const [flag, setFlag] = useState("");
    const [isSolved, setIsSolved] = useState(false);

    const { search } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        // 1. MONKEY PATCHING WINDOW.ALERT
        const originalAlert = window.alert;
        window.alert = (message) => {
            setIsSolved(true); 
            originalAlert(message); 
        };

        // 2. Handle the Reflected Logic
        const params = new URLSearchParams(search);
        const name = params.get('name');

        if (name) {
            fetch(`https://iiuccsc-ctf.vercel.app/api/greet?name=${name}`)
                .then(res => res.json())
                .then(data => {
                    setReflectedName(data.reflected);
                    setFlag(data.flag);
                });
        }

        return () => { window.alert = originalAlert; };
    }, [search]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if(nameInput.trim()) {
            navigate(`?name=${encodeURIComponent(nameInput)}`);
        }
    };

    return (
        <Container className="py-5">
            <Row className="justify-content-center text-center mb-5">
                <Col lg={8}>
                    <h6 className="text-uppercase fw-bold text-warning mb-2" style={{ letterSpacing: '2px' }}>
                        Security Lab
                    </h6>
                    <h1 className="display-4 fw-bold mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                         Greeting Challenge
                    </h1>
                    <p className="lead text-muted">
                        Our greeting system is experimental. Can you bypass the input filters to extract the encrypted flag?
                    </p>
                </Col>
            </Row>

            <Row className="justify-content-center">
                <Col md={10} lg={8}>
                    {/* Input Card */}
                    <Card className="border-0 shadow-sm rounded-4 mb-4">
                        <Card.Body className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <Form.Label className="fw-bold mb-3">Enter Visitor Name</Form.Label>
                                <InputGroup size="lg" className="mb-2">
                                    <Form.Control
                                        value={nameInput}
                                        onChange={(e) => setNameInput(e.target.value)}
                                        className="rounded-start-pill border-end-0"
                                    />
                                    <Button 
                                        variant="dark" 
                                        type="submit" 
                                        className="rounded-end-pill px-4"
                                        style={{ backgroundColor: '#5d4037', border: 'none' }}
                                    >
                                         Greet
                                    </Button>
                                </InputGroup>
                                <Form.Text className="text-muted">
                                    The server will reflect your input directly into the DOM.
                                </Form.Text>
                            </Form>
                        </Card.Body>
                    </Card>

                    {/* Reflection Terminal Area */}
                    {reflectedName && (
                        <Card className="bg-dark border-0 shadow-lg rounded-4 overflow-hidden mb-4">
                            <div className="bg-secondary bg-opacity-25 px-3 py-2 d-flex align-items-center">
                                <div className="d-flex gap-1 me-3">
                                    <div style={{width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ff5f56'}}></div>
                                    <div style={{width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ffbd2e'}}></div>
                                    <div style={{width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#27c93f'}}></div>
                                </div>
                                <small className="text-light opacity-50 font-monospace">system_output.log</small>
                            </div>
                            <Card.Body className="p-4">
                                <div className="font-monospace text-light">
                                    <span className="text-warning font-monospace">guest@campus-grind:~$</span> 
                                    {/* <span className="ms-2">echo "Hello, " + input;</span> */}
                                    <div className="mt-3 p-3 rounded bg-black bg-opacity-50 border border-secondary border-opacity-25">
                                        <span className="text-info">Output: </span>
                                        {/* VULNERABLE POINT */}
                                        <span className="text-white" dangerouslySetInnerHTML={{ __html: reflectedName }} />
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    )}

                    {/* Flag Success Section */}
                    {isSolved ? (
                        <Alert variant="success" className="border-0 shadow-lg rounded-4 p-4 animate__animated animate__bounceIn">
                            <div className="d-flex align-items-center">
                                {/* <div className="display-4 me-4">🎯</div> */}
                                <div>
                                    <h4 className="alert-heading fw-bold">XSS Execution Confirmed!</h4>
                                    <p className="mb-2">The browser state has been compromised. Payload successfully triggered <code>window.alert()</code>.</p>
                                    <hr />
                                    <div className="bg-white p-3 rounded-3 border d-inline-block w-100">
                                        <span className="text-muted small d-block mb-1">DECRYPTED FLAG:</span>
                                        <code className="fs-4 fw-bold text-success">{flag}</code>
                                    </div>
                                </div>
                            </div>
                        </Alert>
                    ) : (
                        reflectedName && (
                            <div className="text-center">
                                {/* <Badge bg="light" text="dark" className="border px-3 py-2 fw-normal">
                                    <Spinner animation="grow" size="sm" variant="secondary" className="me-2" />
                                    Waiting for script execution...
                                </Badge> */}
                            </div>
                        )
                    )}
                </Col>
            </Row>

          
        </Container>
    );
}

export default Greet;